<template>

    <div class="flex flex-col min-h-screen">

        <div v-if="auth" style="padding-bottom:64px">
            <div class="z-40 fixed flex items-center w-full p-4 bg-poly-green text-white shadow">
                <div class="flex-auto">{{ auth.firstname }} {{ auth.lastname }} ({{ auth.email }})</div>
                <button @click="logout" type="submit" style="background-color:#e13a3e!important;color:white!important;font-size:0.8rem">Log Out</button>
            </div>
        </div>

        <div class="hidden sm:block" style="padding-bottom:76px">
            <div class="z-40 fixed flex w-full bg-white" style="border-bottom:1px solid #eee;">
                <div class="flex items-center w-full py-4" style="margin:0 10%">
                    <div class="mr-8">
                        <a href="https://www.polyflor.co.za">
                            <img alt="Polyflor"
                                 src="wp-content/uploads/2017/12/polyflor-logo-x1-1.png"
                                 srcset="wp-content/uploads/2017/12/polyflor-logo-x1-1.png 1x, wp-content/uploads/2017/12/polyflor-logo-x2-1.png 2x"
                                 style="width:135px;" />
                        </a>
                    </div>
                    <div class="flex-auto"></div>
                    <div class="inline-flex items-center justify-end flex-wrap text-grey">
                        <div class="leading-tight text-grey-dark font-bold">ONLINE ADVISOR</div>
                        <div class="px-4">|</div>
                        <div class="leading-tight"><a href="https://www.polyflor.co.za/">Return to <b>polyflor.co.za</b></a></div>
                    </div>
                </div>
            </div>
        </div>

        <div class="flex-auto relative" style="margin:0 10%;">

            <Spinner v-if="stateLoading" :mask="true" />

            <router-view/>

        </div>

        <div style="border-top:1px solid #eee;">
            <div style="margin:0 10%;padding:30px 0;">
                <div class="flex items-center justify-center">
                    <div class="text-xs leading-tight text-grey-darker">© 2019 <a class="text-grey-darker hover:text-poly-red" href="https://www.polyflor.co.za/" target="_blank">Polyflor</a>. Online Advisor by <a class="text-grey-darker hover:text-poly-red" href="https://clevva.com/" target="_blank">CLEVVA</a>.</div>
                    <div class="flex-auto"></div>
                    <div>
                        <div class="inline-flex items-center justify-center">
                            <a class="text-grey-dark hover:text-poly-red" target="_blank" href="https://www.facebook.com/PolyflorSA/"><i class="fa fa-facebook"></i></a>
                            <a class="text-grey-dark hover:text-poly-red" target="_blank" href="https://www.linkedin.com/company/3506674/?trk=vsrp_companies_cluster_name&amp;trkInfo=VSRPsearchId%3A168799291438251891528%2CVSRPtargetId%3A3506674%2CVSRPcmpt%3Acompanies_cluster"><i class="fa fa-linkedin"></i></a>
                            <a class="text-grey-dark hover:text-poly-red" target="_blank" href="https://www.instagram.com/polyflorsouthafrica/"><i class="fa fa-instagram"></i></a>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <portal-target name="modals"></portal-target>

    </div>

</template>

<script>

import { mapState, mapActions } from 'vuex'

export default {

    name: 'App',

    computed: {

        ...mapState(['stateLoading', 'routeName']),

        auth() {
            var auth = localStorage.getItem('auth') || false;
            return auth ? JSON.parse(auth) : false;
        }

    },

    methods: {

        ...mapActions(['scrollToTop']),

        goHome() {
            this.routeName === 'home' ? this.scrollToTop() : this.$router.push({ name: 'home' });
        },

        logout() {
            localStorage.removeItem('auth');
            location.reload();
        }

    }

}
</script>
